// ==========================================================================
// M01 - GLOBAL HEADER
// ==========================================================================

(function(NAMESPACE, $) {

	'use strict';

	/**
	 * Global header functions
	 *
	 * @namespace globalHeader
	 * @memberof DDIGITAL
	 * @version 1.0.0
	 * @author Deloitte Digital Australia
	 */
	NAMESPACE.globalHeader = (function() {
		var SELECTORS,
			init,
			callbacks = new $.Callbacks(),
			_openLoginMenu,
			closeLoginMenu,
			toggleLoginMenu;

		SELECTORS = {
			GLOBAL_HEADER: '.global-header',
			LOGIN_BUTTON: '.login',
			LOGIN_OPTIONS: '.login-options',
			LOGIN_CLOSE: '.login-close',
			LOGIN_DESCRIPTION: '#login-description'
		};

		// Let 'button' be the login button.
		var button = document.querySelector(SELECTORS.LOGIN_BUTTON);
		// 	Let 'menu' be the navigation menu associated with 'button'.
		var menu = document.querySelector(SELECTORS.LOGIN_OPTIONS);

		/**
		 * Open login menu
		 * @memberof DDIGITAL.globalHeader
		 */
		_openLoginMenu = function() {
			callbacks.add(function() {
				$(SELECTORS.LOGIN_DESCRIPTION).focus();
			});

			// Update assistive technologies about the status of 'button'.
			menu.setAttribute('aria-hidden', false);
			button.setAttribute('aria-label', 'Click to close the Login menu');
			button.setAttribute('aria-expanded', true);

			callbacks.fire();
		};

		/**
		 * Close login menu
		 * @param {Event} event - The event object.
		 * @memberof DDIGITAL.globalHeader
		 * @listens MouseEvent#click
		 */
		closeLoginMenu = function(event) {
			// Let 'target' be the target of this event.
			var target = event.target;

			// If 'target' is anything but 'button' and 'menu'.
			if (target !== button && target !== menu) {
				// Hide 'menu'.
				button.classList.remove('opened');
				// Update assistive technologies about the status of 'button'.
				menu.setAttribute('aria-hidden', true);
				button.setAttribute('aria-label', 'Click to open the Login menu');
				button.setAttribute('aria-expanded', false);
				// Set focus to 'button'.
				button.focus();

				// Stop listening for click events outside 'menu' since 'menu' is now hidden.
				document.removeEventListener('click', closeLoginMenu, true);
			}
		};

		/**
		 * Toggle login menu
		 * @memberof DDIGITAL.globalHeader
		 * @listens Event#click
		 */
		toggleLoginMenu = function() {
			// Let 'classList' be a collection of class values associated with 'button'.
			var classList = button.classList;
			// Hide or show 'menu' accordingly.
			classList.toggle('opened');

			// If 'menu' is visible.
			if (classList.contains('opened')) {
				// Listen for click events occurring outside 'menu'.
				document.addEventListener('click', closeLoginMenu, true);
				_openLoginMenu();
			} else {
				closeLoginMenu({});
			}
		};

		init = function() {
			button.addEventListener('click', toggleLoginMenu, true);
		};

		return {
			init: init,
			closeLoginMenu: closeLoginMenu,
			toggleLoginMenu: toggleLoginMenu
		};
	}());

}(DDIGITAL, jQuery));
